

























import { defineComponent, toRefs, PropType, computed, ref, watch } from '@vue/composition-api';
import {
  AcoFormData,
  AdgroupFormData,
  CampaignFormData,
  FormItem,
  FullNormalFormData,
  NormalCreative,
} from '@tt4b/ttam-enums';
import InstantPage from './index';
import { useStdCreativeAdgroupIs, useStdCampaignIs } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-instant-page-compose';
export default defineComponent({
  name,
  components: {
    TtamInstantPageEditor: InstantPage.TtamInstantPageEditor,
    TtamInstantPageErrorTip: InstantPage.TtamInstantPageErrorTip,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    normalCreative: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: 'create',
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, creativeData, normalCreative, createMode } = toRefs(props);
    const { visible: tipVisible } = InstantPage.usePropsErrorTipVisible({
      creativeData,
      campaignData,
    });
    const isLoading = computed(() => creativeData.value.pageInfo?.loading);
    // 获取预览地址
    const { previewUrl } = InstantPage.usePropsPreviewUrl({
      campaignData,
      adgroupData,
      creativeData,
      normalCreative,
      createMode,
    });

    const { isStandardAdsWithCatalog } = useStdCreativeAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    const { isLeadAdsAutoInventoryAds } = useStdCampaignIs({
      campaignFormData: campaignData,
    });

    const previewClickTrackEventName = computed(() => {
      if (isStandardAdsWithCatalog.value) {
        return 'module_ad_creative_nonshop_landing_page_preview_click';
      }

      if (isLeadAdsAutoInventoryAds.value) {
        return 'module_ad_creative_aia_page_preview_click';
      }

      return 'module_ad_creative_shop_landing_page_preview_click';
    });

    const previewShowTrackEventName = computed(() => {
      if (isStandardAdsWithCatalog.value) {
        return 'module_ad_creative_nonshop_landing_page_preview_impression';
      }

      if (isLeadAdsAutoInventoryAds.value) {
        return 'module_ad_creative_aia_page_preview_impression';
      }

      return 'module_ad_creative_shop_landing_page_preview_impression';
    });

    const previewErrorTrackEventName = computed(() => {
      if (isStandardAdsWithCatalog.value) {
        return 'module_ad_creative_instant_page_fail_impression';
      }

      if (isLeadAdsAutoInventoryAds.value) {
        return 'module_ad_creative_aia_page_fail_impression';
      }

      return 'module_ad_creative_landing_page_fail_impression';
    });

    const previewRetryTrackEventName = computed(() => {
      if (isStandardAdsWithCatalog.value) {
        return 'module_ad_creative_instant_page_fail_retry';
      }

      if (isLeadAdsAutoInventoryAds.value) {
        return 'module_ad_creative_aia_page_fail_retry';
      }

      return 'module_ad_creative_landing_page_fail_retry';
    });

    const { label } = InstantPage.usePropsInstantPageLabel({
      campaignData,
      adgroupData,
    });
    const form = ref<FormItem>();

    const _pageId = computed({
      get() {
        return creativeData.value.pageId;
      },
      set(val) {
        emit('change', {
          pageId: val,
        });
      },
    });

    const onRetry = () => {
      trackEvent(previewRetryTrackEventName.value);
      emit('retry');
    };

    watch(_pageId, () => {
      form.value?.validate?.('');
    });
    return {
      name,
      label,
      tipVisible,
      isLoading,
      previewUrl,
      form,
      isStandardAdsWithCatalog,
      previewClickTrackEventName,
      previewShowTrackEventName,
      previewErrorTrackEventName,
      onRetry,
    };
  },
});
